import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { MaterialSymbol, TextField, withStyles } from 'vopay';
import styles from './PermissionsSearchField.module.scss';

const cn = withStyles(styles);

type PermissionsSearchFieldProps = {
  value: string;
  onChange: (value: string) => void;
  /**
   * Optional override; defaults to the shared `Global.Buttons.search`
   * placeholder used elsewhere.
   */
  placeholder?: string;
  name?: string;
};

export default function PermissionsSearchField({
  value,
  onChange,
  placeholder,
  name = 'permissionSearch',
}: PermissionsSearchFieldProps) {
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global.Buttons' });

  return (
    <TextField
      name={name}
      placeholder={placeholder ?? tGlobal('search')}
      value={value}
      onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
      variant="outlineShadow"
      elementLeft={<MaterialSymbol icon="search" size="24px" className={cn('icon')} />}
    />
  );
}
